import { getCxmEntities } from '../../../../api-clients/cxm-rules/get-cxm-entities';
import { getCxmRequestContext } from '../../../../api-clients/cxm-rules/utils/get-cxm-request-context';
import { createOrGetFetchedState } from '../../../../utils/fetched-data/create-or-get-fetched-state';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { logger } from '../../../../utils/logger';
import { temporaryBrowsingDomainStore } from '../../temporary-store/store';
export const loadCxmFilmsForComponent = async (entityType, componentId, maximumFilms) => {
    if (!componentId) {
        logger.debug('Cannot load CXM films without a componentId.');
        return undefined;
    }
    const state = createOrGetFetchedState(temporaryBrowsingDomainStore.data.cxmFilmsForComponent, componentId);
    const requestContext = getCxmRequestContext(entityType, componentId, maximumFilms);
    try {
        return await loadDataFromApi({
            api: () => getCxmEntities(requestContext),
            state,
            cacheDuration: getCacheDuration('cxm')
        });
    }
    catch (error) {
        // Don't re-throw error, we will fallback to standard sorting if CXM failed.
        logger.error(`Failed to load CXM films for componentId: "${componentId}".`);
        return undefined;
    }
};
